import { ChakraFlex } from '@equip.health/ui';
import SectionHeader from '~/components/common/SectionHeader';
import { useOverdueCoreAssessments } from '~/lib/hooks/useOverdueCoreAssessments';
import { OverdueAssessmentsCardList } from './OverdueAssessmentsCardList';

interface OverdueAssessmentsSectionProps {
  patientId: string;
  onClickCompleteTogether: (surveyResponse: SurveyResponse) => void;
  // Optional header variant to support different typography in different contexts
  headerVariant?: 'h5' | 'bodyMedium';
}

const OverdueAssessmentsSection = ({
  patientId,
  onClickCompleteTogether,
  headerVariant = 'h5',
}: OverdueAssessmentsSectionProps) => {
  const { admitDate, isLoading, overdueCoreAssessments } =
    useOverdueCoreAssessments(patientId);

  return (
    <ChakraFlex
      data-testid="overdue-assessments-section"
      flexDirection="column"
      gap="12px"
    >
      <SectionHeader
        badge={{
          count: overdueCoreAssessments.length,
          counterId: 'overdue-assessments__counter',
          type: 'counter',
        }}
        headerText="Overdue assessments"
        variant={headerVariant}
      />
      <OverdueAssessmentsCardList
        admitDate={admitDate}
        isLoading={isLoading}
        onClickCompleteTogether={onClickCompleteTogether}
        overdueAssessments={overdueCoreAssessments}
      />
    </ChakraFlex>
  );
};

export default OverdueAssessmentsSection;
